import { render, staticRenderFns } from "./payBack.vue?vue&type=template&id=68589bba&scoped=true"
import script from "./payBack.vue?vue&type=script&lang=js"
export * from "./payBack.vue?vue&type=script&lang=js"
import style0 from "./payBack.vue?vue&type=style&index=0&id=68589bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68589bba",
  null
  
)

export default component.exports